// Copyright (c) 2016 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import DealerRecommendationConfirmModal, {getDefaultState as getDealerRecommendationConfirmModalDefaultState} from './dealer-recommendation-confirm-modal';
import DealerRecommendationList, {getDefaultState as getDealerRecommendationListDefaultState} from './dealer-recommendation-list';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    dealerRecommendationModal: DealerRecommendationConfirmModal,
    dealerRecommendations: DealerRecommendationList,
    facets: Facets,
    hasSearchResults: t.Boolean,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String,
    selectedDealerRecommendations: DealerRecommendationList
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        dealerRecommendationModal: getDealerRecommendationConfirmModalDefaultState(),
        dealerRecommendations: getDealerRecommendationListDefaultState(),
        facets: getFacetsDefaultState(),
        hasSearchResults: false,
        reportsAccordion: getAccordionDefaultState('transfer-approvals-reports'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: '',
        selectedDealerRecommendations: getDealerRecommendationListDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/state/index.js